import { Config } from '../../config'

export const srsConfig: Config = {
  partner: 'srs',
  catalog: 'partner',
  displayName: 'SRS',
  accentColor: '#007aff',
  host: 'seating.srsonline.com',
}

